// 登入模式
export enum LoginMode {
  ACCOUNT = 'accountLogin',
  MOBILE = 'mobileLogin',
}

// 登入欄位類型
export enum LoginType {
  ACCOUNT = 'account',
  PASSWORD = 'password',
  GOOGLE_VALID_CODE = 'googleCode',
  TELEPHONE = 'telephone',
  VALID_CODE = 'validCode',
}
